import {StickerType, TextStickerState} from 'yougile-model'
import {ACustomStickerCtl} from '@extensions/sticker/controllers/a-custom-sticker-ctl'

export class NumericCtl extends ACustomStickerCtl<TextStickerState> {
  public get type(): StickerType {
    return 'numeric'
  }

  makeNewState(): TextStickerState {
    return {
      id: this.makeShortId(),
      text: ''
    }
  }
}
